import React from 'react';
import './floating.css';

const FloatingDecor = () => {
    return (
        <div className="decor-container">
            <div className="floating-item item-1">A</div>
            <div className="floating-item item-2">1</div>
            <div className="floating-item item-3">B</div>
            <div className="floating-item item-4">2</div>
            <div className="floating-item item-5">C</div>
            <div className="floating-item item-6">3</div>
            <div className="floating-item item-1" style={{ top: '70%', left: '80%', color: '#ffeb3b' }}>⭐</div>
            <div className="floating-item item-2" style={{ top: '80%', left: '25%', color: '#ff007f' }}>⚽</div>
            <div className="floating-item item-4" style={{ top: '30%', left: '40%', opacity: 0.05, fontSize: '12rem' }}>🎨</div>
        </div>
    );
};

export default FloatingDecor;
